import React from 'react';
import { TableHead, TableCell, TableSortLabel, TableRow, withStyles } from '@material-ui/core';
import WeekDateCells from '../shared/tableCells/WeekDateCells';
import '../shared/Table.css';

const CustomTableSortLabel = withStyles(theme => ({
  icon: {
    fill: '#B4B4C6'
  }
}))(TableSortLabel);

// TODO: make these sortable

const Header = ({ weekDates, employeeCount }) => {
  return (
    <TableHead>
      <TableRow style={{ backgroundColor: '#F1F1F3' }}>
        <TableCell>
          <CustomTableSortLabel style={{ fontSize: 12, color: '#2E2E39', fontWeight: 600 }}>
            <div>
              <p className='row-label'>Employees</p>
              <p className='row-sub-label' style={{ textAlign: 'left' }}>{employeeCount} total</p>
            </div>
          </CustomTableSortLabel>
        </TableCell>
        <WeekDateCells weekDates={weekDates} />
        <TableCell>
          <p className='row-label'>Total Hours</p>
          <p className='row-sub-label'>(This Week)</p>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default Header;
